import React from 'react';
import { Load } from 'base/load';
import { Link } from 'react-router-dom';
import "pages/style.css"

export class MainPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inspectors: [],
            selectedInsp: 0
        };
        this.get = this.get.bind(this);
    }

    componentDidMount() {
        this.get();
    }

    get() {
        new Load(this.context, "Получение списка инспекторов", "/api/get/inspectors")
            .SetErr()
            .Load()
            .then((inspectors) => {
                this.setState({
                    inspectors: inspectors
                });
            });
    }

    render() {
        const insp = this.state.inspectors
        return (
            <div className='main'>
                
                    {Object.keys(insp).map(key => (
                        <Link to={{
                            pathname: `/inspector/${insp[key].id}`,
                            state: { lastname: insp[key].inspector.lastname, name: insp[key].inspector.name, surname: insp[key].inspector.surname }
                        }}>
                            <button className='custom-btn btn-1'
                                key={insp[key].id}
                            >{insp[key].inspector.lastname + " " + insp[key].inspector.name + " " + insp[key].inspector.surname}</button>
                            <br />
                        </Link>
                        
                    ))}

                <br />       
                <Link to={
                    { pathname: `/add/inspector` }
                }>
                    <button className='custom-btn btn-1'>Добавить инспектора</button>
                </Link>
                <br />
                <Link to={
                    { pathname: `/add/event` }
                }><button className='custom-btn btn-1'>Добавить мероприятие</button>
                </Link>
                <br />
                <Link to={
                    { pathname: `/all/events` }
                }>
                    <button className='custom-btn btn-1'>Редактировать мероприятие</button>
                </Link>
                <br />
                <button className='custom-btn btn-1'>Выгрузить все мероприятия</button>
            </div>
        );
    }
}